import { MobileView } from './views/MobileView';
import { DesktopView } from './views/DesktopView';
import { AssistantPracticeChat } from '@modules/patient/store/ehr/types';
import { store } from '@store';
import { useDataLoading } from '@utils/hooks/useDataLoading';
import { subscriptionOrderService } from '../../pages/SubscriptionOrderPage/services/SubscriptionOrderService';
import { SubscriptionOrderStatus } from 'chaika-enums';

export interface CenterContentProps {
    fullName: string;
    birthDate?: string;
    age: string;
    link: string;
    recordId: number;
    phone?: string;
    isMobile: boolean;
    email?: string;
    assistantsChats: AssistantPracticeChat[];
    isPatientPage: boolean;
}

export function Center(props: CenterContentProps) {
    const { ehr } = store;

    useDataLoading(async () => {
        if (ehr.id && !subscriptionOrderService.isLoaded) {
            await subscriptionOrderService.load({ patientId: ehr.id, status: SubscriptionOrderStatus.Active });
        }
    }, [ehr.id]);

    return props.isMobile ? <MobileView /> : <DesktopView {...props} />;
}
